import { AppNS } from 'app';

import { parseJobData, parseLeadProposal } from '../common-parsers/common-parsers';

export const normalizeToLead = (data: AppNS.Params): AppNS.ProjectLead => {
  return {
    id: data.id,
    agency: data.agency,
    agencyCompany: data.agencyCompany,
    client: data.client,
    job: data.job,
    permitNumbers: data.job.permitNumbers,
    startDate: data.job.startDate,
    endDate: data.job.startDate,
    clientId: '',
    state: data.state,
    paymentMethodId: data.paymentMethodId,
  } as unknown as AppNS.ProjectLead;
};

export const parseProjectLead = (data: AppNS.Params): AppNS.ProjectLead => {
  data.endDate = data.job.endDate;
  data.startDate = data.job.startDate;

  data.job = parseJobData({
    ...data.job,
    client: data.client,
    agency: data.agency,
    agencyCompany: data.agencyCompany,
  });
  data.proposal = parseLeadProposal(data.jobLead || data);

  return data as AppNS.ProjectLead;
};

export const preparePickedPermitsToAdd = (data: Array<AppNS.PickedPermit>): AppNS.Params => {
  const pickedPermits = data.filter((permit) => permit.isOn);
  return pickedPermits.map((pickedPermit) => {
    return {
      inspection_group: pickedPermit.inspectionGroup,
      inspection_types: pickedPermit.inspections,
      permit_number: pickedPermit.id,
      scope: pickedPermit.scope,
      wall_check_required: pickedPermit.wallCheckRequired,
      wall_check_complete: pickedPermit.wallCheckComplete,
    };
  });
};
